<div class="container" *ngIf="isLoading">
  <div class="center">
    <mat-spinner [diameter]="50" [strokeWidth]="3"></mat-spinner>
  </div>
</div>

<div class="container" *ngIf="isLoadingComplete()">
  <div class="header">
    <div class="title_div">
      <div class="flex_row">
        <div class="title">Your Datasets</div>
        <div class="table_count">(using {{ getProjectCount() }} of {{ maxProjects }})</div>
      </div>
      <div class="create_btn_wrapper">
        <div class="subtitle">Manage and interact with your custom datasets using visualization methods.</div>
        <div class="btn_wrapper">
          <div
            *ngIf="selectedProjects.length > 0"
            class="trash_btn"
            (click)="deleteSelected()"
            (keyup.enter)="deleteSelected()"
            tabindex="0"
            role="button"
            aria-label="delete selected"
          >
            <i class="bi bi-trash"></i>
          </div>
          <div
            *ngIf="selectedProjects.length == 0"
            class="hidden_trash_btn"
            tabindex="0"
            role="button"
            aria-label="delete selected, none selected"
          ></div>
          <button
            class="create_btn"
            (keydown.enter)="goToCreation()"
            (click)="goToCreation()"
            *ngIf="yourProjects && getProjectCount() < maxProjects"
          >
            + Create New Dataset
          </button>
          <button class="disable_btn" disabled *ngIf="!(yourProjects && getProjectCount() < maxProjects)">
            + Create New Dataset
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table" *ngIf="yourProjects.length > 0">
    <div class="table_header">
      <div class="select_col">
        <div
          class="checkbox"
          tabindex="0"
          role="checkbox"
          (click)="selectAllProjects()"
          (keyup.enter)="selectAllProjects()"
        >
          <i class="bi bi-check2" *ngIf="isAllSelected()"></i>
        </div>
      </div>
      <div class="name_col">NAME</div>
      <div class="date_range_col">DATE RANGE</div>
      <div class="search_col">SEARCH</div>
      <div class="data_source_col">DATA SOURCE</div>
      <div class="docs_col">DOC COUNT</div>
      <div class="date_created_col">DATE CREATED</div>
      <div class="vis_col"></div>
      <div class="delete_col"></div>
    </div>

    <ng-container *ngFor="let project of yourProjects; let ind = index">
      <!-- <p>{{ project | json }}</p> -->
      <div
        [ngClass]="isChecked(project.id) ? 'table_rows expanded' : 'table_rows'"
        tabindex="0"
        role="row"
        (click)="selectProject(project)"
        (keyup.enter)="selectProject(project)"
      >
        <div class="select_col">
          <div class="checkbox" role="checkbox" attr.aria-checked="isChecked(project.id)">
            <i *ngIf="isChecked(project.id)" class="bi bi-check2"></i>
          </div>
        </div>
        <!--name-->
        <div class="name_col">
          <b>
            {{
              !isChecked(project.id) && project.name.length > 225
                ? (project.name | slice : 0 : 225) + "..."
                : project.name
            }}
          </b>
        </div>

        <!--date range-->
        <div class="date_range_col">{{ getDateRange(project) }}</div>

        <!--search-->
        <div class="search_col">
          {{
            !isChecked(project.id) && project.search.query.length > 225
              ? (project.search.query | slice : 0 : 225) + "..."
              : project.search.query
          }}
        </div>

        <!--data source-->
        <div class="data_source_col">
          <div class="data_source">
            <p *ngIf="getPublications(project).length > 0 || getPubs(project).length > 0"><b>Publication Titles</b></p>
            <p *ngFor="let pub of getPublications(project)">{{ pub }}</p>
            <p *ngFor="let pub of getPubs(project)">{{ pub }}</p>
            <p *ngIf="getDbs(project).length > 0" [ngClass]="getPubs(project).length > 0 ? 'space' : 'no_space'">
              <b>Databases</b>
            </p>
            <p *ngFor="let db of getDbs(project)">{{ db }}</p>
          </div>
        </div>

        <!--doc count-->
        <div class="docs_col">{{ project.docCount }}</div>

        <!--date created-->
        <div class="date_created_col">{{ getDate(project) }}</div>

        <!--status section-->
        <div class="vis_col" *ngIf="project.status !== 'deleting'">
          <div class="vis_wrapper">
            <!--geo status-->
            <div
              class="method_info"
              *ngIf="this.isGeoAnalysis(project) && getGeoStatus(project) === 'completed'"
              tabindex="0"
              role="link"
              attr.aria-label="Geographic Analysis"
              (click)="goToGeoAnalysis(project)"
              (keyup.enter)="goToGeoAnalysis(project)"
            >
              <img class="globe" src="../../../assets/images/globe.svg" />
              <p class="method_text">Geographic Analysis</p>
            </div>

            <!--topic status-->
            <div
              class="method_info"
              *ngIf="isTopicAnalysis(project) && getTopicStatus(project) === 'completed'"
              tabindex="0"
              role="link"
              attr.aria-label="Topic Modeling"
              (click)="goToTopicAnalysis(project)"
              (keyup.enter)="goToTopicAnalysis(project)"
            >
              <img class="topic" src="../../../assets/images/topic-icon.svg" />
              <p class="method_text">Topic Modeling</p>
            </div>

            <!--sentiment status-->
            <div
              class="method_info"
              *ngIf="isSentimentAnalysis(project) && getSentimentStatus(project) === 'completed'"
              tabindex="0"
              role="link"
              attr.aria-label="Sentiment Analysis"
              (click)="goToSentimentAnalysis(project)"
              (keyup.enter)="goToSentimentAnalysis(project)"
            >
              <img class="topic" src="../../../assets/images/sa-icon.svg" />
              <p class="method_text">Sentiment Analysis</p>
            </div>

            <div class="loading status" *ngIf="isInProgress(project)">
              <i class="bi bi-clock"></i>
              <p>In-Progress</p>
            </div>

            <div class="loading_list">
              <div
                class="loading_text"
                *ngIf="
                  project.status === 'failed' ||
                  getGeoStatus(project) === 'failed' ||
                  getTopicStatus(project) === 'failed' ||
                  getSentimentStatus(project) === 'failed'
                "
              >
                <div class="failed_text" aria-disabled="true" tabindex="0" aria-label="Job status failed">
                  <i class="bi bi-exclamation-triangle deleting"></i>
                  <p class="deleting">Failed</p>
                  <div
                    (mouseover)="handleMouseOver(ind)"
                    (mouseleave)="handleMouseLeave()"
                    (focus)="handleMouseOver(ind)"
                    (blur)="handleMouseLeave()"
                    (keydown)="handleKeydown($event, ind)"
                    class="helpIcon"
                    tabindex="0"
                    aria-describedby="datasetTooltip"
                  >
                    <i class="bi bi-exclamation-circle"></i>
                    <div *ngTemplateOutlet="datasetBubbleTemplate; context: { showBubble: hoveredIndex === ind }"></div>
                  </div>
                </div>
              </div>

              <div class="loading_text" *ngIf="isGeoAnalysis(project) && (getGeoStatus(project) === 'failed' || getGeoStatus(project) === 'queued')">
                <p>Geographic Analysis</p>
              </div>

              <div class="loading_text" *ngIf="isTopicAnalysis(project) && (getTopicStatus(project) === 'failed' || getTopicStatus(project) === 'queued')">
                <p>Topic Modeling</p>
              </div>

              <div
                class="loading_text"
                *ngIf="isSentimentAnalysis(project) && (getSentimentStatus(project) === 'failed' || getSentimentStatus(project) === 'queued')"
              >
                <p>Sentiment Analysis...</p>
              </div>
            </div>
          </div>
        </div>
        <div class="vis_col" *ngIf="project.status === 'deleting'">
          <div class="deleting status">
            <i class="bi bi-x-circle"></i>
            <p>Deleting</p>
          </div>
        </div>
        <!--end of status-->

        <!--delete-->
        <div class="delete_col">
          <div
            class="trash_btn"
            (click)="delete([project]); selectProject(project)"
            (keyup.enter)="delete([project]); selectProject(project)"
            tabindex="0"
            role="button"
            aria-label="delete"
          >
            <i class="bi bi-trash"></i>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #datasetBubbleTemplate let-showBubble="showBubble">
      <div
        class="dataset-bubble"
        *ngIf="showBubble"
        id="datasetTooltip"
        role="tooltip"
        aria-live="polite"
        tabindex="-1"
      >
        <div class="helpwrapper">
          <div class="help">Analysis could not be completed</div>
          <div class="helptext">
            Analysis can occasionally fail due to unique features of your dataset that we haven't encountered before. We
            are continuously working to address new issues and improve our system to handle diverse datasets more
            effectively.
          </div>
          <div class="helptext">
            <p>To resolve this, you can try the following:</p>
            <ul>
              <li>Adjust the date range of your dataset.</li>
              <li>Select different publication titles.</li>
              <li>Select a single source type (e.g. Newspapers, Dissertations & Theses)</li>
            </ul>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
